var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 35 35",
    enableBackground: "new 0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.04,0.04)",
    fill: "#8CC63F",
    d: "M518.559,154.501C644.718,40.234,832.569,29.61,832.569,29.61S281.633,10.742,409.934,425.83 C411.658,284.106,453.845,213.114,518.559,154.501z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.04,0.04) ",
    fill: "#8CC63F",
    d: "M830.188,30.623c0,0-187.216,18.715-308.331,138.316c-61.847,61.071-100.846,133.459-96.87,273.871 c-8.589,109.681-96.881,298.099-96.881,298.099c19.369,50.857,66.225,15.099,66.225,15.099 c-16.572-52.616,63.455-290.286,71.126-312.839C586.736,434.708,932.965,380.091,830.188,30.623z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.04,0.04) ",
    fill: "#8CC63F",
    d: "M261.962,310.281C177.271,233.57,51.157,226.44,51.157,226.44s369.861-12.668,283.73,265.996 C333.729,397.29,305.405,349.63,261.962,310.281z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.04,0.04) ",
    fill: "#8CC63F",
    d: "M52.756,227.119c0,0,125.684,12.563,206.995,92.856c41.517,40.998,67.699,89.597,65.031,183.858 c5.764,73.632,65.038,200.123,65.038,200.123c-13,34.142-44.46,10.138-44.46,10.138c11.129-35.322-42.596-194.88-47.748-210.021 C216.193,498.394-16.24,461.727,52.756,227.119z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoIcon);
export default __webpack_public_path__ + "static/media/ecoIcon.42240cd9.svg";
export { ForwardRef as ReactComponent };